import PropTypes from 'prop-types'
import { Component, createElement } from 'react'
import copy from 'copy-to-clipboard'

export default ({ getContentFromProps }) => OriginalComponent => {
  return class CopyOnClick extends Component {
    static propTypes = {
      children: PropTypes.node.isRequired,
      contentOnCopy: PropTypes.node.isRequired,
    }

    static defaultProps = {
      contentOnCopy: 'Copied',
    }

    state = {
      justCopied: false,
    }

    render() {
      const { children, contentOnCopy } = this.props
      const { justCopied } = this.state
      const { onClick } = this

      return createElement(
        OriginalComponent,
        { ...this.props, onClick },
        justCopied ? contentOnCopy : children
      )
    }

    onClick = () => {
      clearTimeout(this.handle)

      this.setState(state => ({
        ...state,
        justCopied: true,
      }))

      copy(getContentFromProps(this.props))

      this.handle = setTimeout(() => {
        this.setState(state => ({
          ...state,
          justCopied: false,
        }))
      }, 1500)
    }
  }
}
